export default __webpack_public_path__ + "06d3f4a4b22540c19332980f42c4d9cf.svg";